export function amountFormat(amount, locale = 'en-IN') {
  if (isNaN(amount)) return '';

  return new Intl.NumberFormat(locale).format(amount);
}
